/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-14 11:36:57
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-02-14 11:41:30
 * @name: 工单管理-申报详情
 * @Description: 工单管理-申报详情
 * @FilePath: \preSaleNafterSaleInside\project\src\Validator\issue\detail.js
 * @Author: desktop
 */
export const validator = [
  {
    key: 'issue_id',
    description: '工单ID',
    required: true,
    required_message: '工单ID为必传项',
    match: (e) => {
      return '';
    }
  },
]